import React from 'react';

const Email = ({ svgRef, title, ...props }) => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 25 16" width="1em" height="1em" ref={svgRef} {...props}>
    <title>{title}</title>
    <defs>
      <path id="Email_a" d="M802.45 329.15l-11.67 8.62c-.37.3-.82.3-1.11 0L778 329.15v12.63c0 .15.15.22.3.22h23.85c.15 0 .3-.07.3-.22z" />
      <path id="Email_b" d="M778 326.67l11.67 8.62c.3.3.74.3 1.11 0l11.67-8.62v-.37c0-.15-.15-.3-.3-.3H778.3c-.15 0-.3.15-.3.3z" />
    </defs>
    <use fill="currentColor" xlinkHref="#Email_a" transform="translate(-778 -326)" />
    <use fill="currentColor" xlinkHref="#Email_b" transform="translate(-778 -326)" />
  </svg>
);

export default Email;



// WEBPACK FOOTER //
// ./src/common/icons/Mail.js